<template>
  <div>
    <panel title="Etapy">
      <w-table
        entity-type="stage"
        :hide-search-input="true"
        :columns="columns"
        :data="list"
        :actions="actions"
        :total="count"
        @add="showAddModal"
        @edit="showEditModal($event.id)"
        @delete="showDeleteDialog($event.id)"
        @editCriterion="editCriterion($event.id)"
        @editOptions="editOptions($event.id)"
      />
    </panel>

    <stage-modal :id="idToEdit" :show="showModal" @save="add" @close="hideModal" @update="update" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import StageModal from '@/components/modals/StageModal';
import Panel from '@/components/panel/Panel';
import WTable from '@/components/table/Table';
import { listMixin } from '@/mixins/list';
import { CRITERION_ACTION, DEFAULT_TABLE_ACTIONS, OPTION_ACTION } from '@/utils/constants';

const messages = {
  listError: 'Wystąpił błąd podczas pobierania etapów.',
  getError: 'Wystąpił błąd podczas pobierania danych etapów.',
  added: 'Dodano etap.',
  addError: 'Nie udało się dodać etapu.',
  updated: 'Zaktualizowano dane etapu.',
  updateError: 'Nie udało się zaktualizować danych etapu.',
  deleteConfirm: 'Czy na pewno chcesz usunąć etap?',
  deleted: 'Usunięto etap.',
  deleteError: 'Nie udało się usunąć etapu.'
};

// @vuese
// Lista etapów
// @group stage
export default {
  components: { Panel, WTable, StageModal },
  mixins: [listMixin('stage', messages)],
  data: () => ({
    columns: [
      { name: 'id', displayName: 'ID' },
      { name: 'name', displayName: 'Nazwa', sortable: true },
      { name: 'type', displayName: 'Typ' }
    ],
    actions: [...DEFAULT_TABLE_ACTIONS, CRITERION_ACTION, OPTION_ACTION]
  }),
  methods: {
    // @vuese
    // Przeniesienie na stronę edycji kryteriów etapu
    editCriterion(stageId) {
      this.$router.push({ name: 'stageCriterionList', params: { stageId } });
    },
    // @vuese
    // Przejście na stronę edycji opcji
    editOptions(stageId) {
      this.$router.push({ name: 'stageOptions', params: { stageId } });
    }
  }
};
</script>
